/**
 * Middleware to track navigation state when moving from checkout to cart.
 *
 * This middleware updates a state variable to indicate whether the user
 * has navigated from the checkout page to the cart page.
 *
 * @returns {void}
 * @example
 * // Automatically tracks navigation from checkout to cart
 * export default defineNuxtRouteMiddleware((to, from) => { ... })
 */
export default defineNuxtRouteMiddleware((to, from) => {
  const { checkoutUrl, cartUrl } = useRouteHelper()
  const isFromCheckoutToCart = useState<boolean>(
    'fromCheckoutToCart',
    () => false
  )

  if (from.path === checkoutUrl && to.path === cartUrl) {
    isFromCheckoutToCart.value = true
  } else {
    isFromCheckoutToCart.value = false
  }
})
